<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      Billing
    </ion-title>
    <ion-buttons slot="end">
      <super-button size="v-small" type="underline" width="fit" [action]="openBranchBilling">
        Manage branch billing
      </super-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>


  <div class="flex flex-col gap-4 p-4">
    <div class="p-4 pb-5 rounded-md overflow-hidden bg-white">
      <p class="m-0 mb-[15px] pb-[10px] text-[var(--ion-color-two)] text-sm border-b border-[var(--ion-color-one)]">
        Plan
      </p>

      @if (!primaryActivePurchases) {
      <div>
        <ion-skeleton-text class="w-full rounded-md overflow-hidden h-20" [animated]="true"></ion-skeleton-text>
      </div>
      }

      @if (primaryActivePurchases && primaryActivePurchases.length < 1) { <div
        class="bg-white flex flex-row justify-between items-center">
        <h1 class="m-0 text-lg">Free Tier</h1>
        <super-button [action]="openPlanUpgrade" size="v-small">Upgrade Plan</super-button>
    </div>
    }

    @if (primaryActivePurchases) {
    <div>
      @for (planPurchase of primaryActivePurchases; track planPurchase._id) {
      <div class="w-full flex flex-row items-start justify-between gap-[5px]">
        <div class="flex flex-col gap-[5px]">
          <p class="text-lg font-bold">{{ planPurchase.plan.name }}</p>
          <div class="flex flex-row text-[var(--ion-color-two)] text-sm">
            @if (planPurchase.autoRenews) {
            <p class="m-0">Your plan renews on {{ planPurchase.expireTime | date : 'dd MMM, yyyy' }}</p>
            } @else {
            <p class="m-0">Your plan expires on {{ planPurchase.expireTime | date : 'dd MMM, yyyy' }}</p>
            }
          </div>
        </div>
        <div class="flex flex-row items-center gap-3 shrink-0">
          @if (showAutoRenewBadge(planPurchase)) {
          <div class="flex flex-row items-center gap-2 bg-slate-100 p-2 rounded-sm">
            <span class="text-sm font-medium text-slate-700">
              Auto-renew
            </span>
            <ion-icon name="checkmark-circle" class="text-slate-700 text-base"></ion-icon>
          </div>
          }
          @if (showManagePlan(planPurchase)) {
          <super-button size="v-small" type="outline" [action]="onManagePlanClicked(planPurchase)">Manage</super-button>
          }
        </div>
      </div>
      }
    </div>
    }

  </div>




  <div class="p-4 rounded-md bg-white">
    <p class="m-0 mb-[15px] pb-[10px] text-[var(--ion-color-two)] text-sm border-b border-[var(--ion-color-one)]">Credit
      Balance
    </p>
    <p class="text-xl text-[var(--ion-color-two)] font-bold">₹ {{apiBalance?.toFixed(2)}}</p>

    <div class="py-[10px] flex flex-col gap-[10px]">

      <div class="flex flex-row justify-between items-center">
        <p class="text-md font-bold m-0">API Usage Cost</p>

        @if (!isShowApiCostLogs) {
        <super-button (click)="onViewApiCostsClicked()" type="clear" size="small"
          iconEnd="chevron-down">View</super-button>
        }

        @if (isShowApiCostLogs) {
        <ion-item>
          <ion-select [(ngModel)]="selectedCostRange" interface="popover" (ionChange)="fetchApiCosts()">
            <ion-select-option>{{DateRange.TODAY}}</ion-select-option>
            <ion-select-option>{{DateRange.THIS_MONTH}}</ion-select-option>
            <ion-select-option>{{DateRange.PREVIOUS_MONTH}}</ion-select-option>
            <ion-select-option>{{DateRange.LAST_30_D}}</ion-select-option>
            <ion-select-option>{{DateRange.CURRENT_YEAR}}</ion-select-option>
          </ion-select>
        </ion-item>
        }
      </div>


      @if (isShowApiCostLogs) {
      <div class="flex flex-col gap-4">
        <div class="flex justify-between items-center">
          <p class="text-sm text-gray-700">Create Document</p>
          @if (isLoadingCosts) {
          <ion-skeleton-text class="w-12 h-5 rounded-md" animated="true"></ion-skeleton-text>
          } @else if (createDocumentApiCost > 0) {
          <p class="text-sm">₹{{ createDocumentApiCost?.toFixed(2) }}</p>
          } @else {
          <p class="text-sm text-gray-400">—</p>
          }
        </div>
        <div class="flex justify-between items-center">
          <p class="text-sm text-gray-700">Fetch Document</p>
          @if (isLoadingCosts) {
          <ion-skeleton-text class="w-12 h-5 rounded-md" animated="true"></ion-skeleton-text>
          } @else if (readDocumentApiCost > 0) {
          <p class="text-sm">₹{{ readDocumentApiCost?.toFixed(2) }}</p>
          } @else {
          <p class="text-sm text-gray-400">—</p>
          }
        </div>
      </div>
      }


    </div>

  </div>

  <!-- Billing History -->
  <div class="px-[15px] pt-[15px] pb-5 rounded-md overflow-hidden  bg-white">
    <p class="m-0 mb-[15px] pb-[10px] text-[var(--ion-color-two)] text-sm border-b border-[var(--ion-color-one)]">
      Billing History
    </p>

    @if (!historyLoaded) {
    <div>
      <ion-skeleton-text class="w-full rounded-md overflow-hidden h-20" [animated]="true"></ion-skeleton-text>
    </div>
    }

    @if (historyLoaded && historyDocs.length < 1) { <p class="m-0 text-[var(--ion-color-two)] text-sm">No purchases
      yet</p>
      }

      @if (historyLoaded && historyDocs.length > 0) {
      <table class="billing-history-table">
        <thead>
          <tr>
            <th>Plan</th>
            <th>Billing</th>
            <th>Amount (incl. tax)</th>
            <th>Purchased On</th>
            <th>Status</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
          @for (order of historyDocs; track order._id) {
          <tr>
            <td>{{ order.plan?.name || '—' }}</td>
            <td>{{ order.renewalPeriod || '—' }}</td>
            <td>
              @if (getOrderAmount(order) !== null) {
              ₹{{ getOrderAmount(order) }}
              } @else {
              —
              }
            </td>
            <td>{{ order.createTime | date : 'dd MMM, yyyy' }}</td>
            <td>
              <span class="status-badge" [class.active]="isOrderPaid(order)" [class.expired]="!isOrderPaid(order)">
                {{ getOrderStatusLabel(order) }}
              </span>
            </td>
            <td>
              @if (order.invoiceNumber) {
              <button type="button" class="invoice-download" (click)="downloadInvoice(order)"
                [disabled]="downloadingInvoiceId === order._id">
                <span class="invoice-number">{{ order.invoiceNumber }}</span>
              </button>
              } @else {
              —
              }
            </td>
          </tr>
          }
        </tbody>
      </table>

      <ion-infinite-scroll (ionInfinite)="infiniteLoad($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
      }
  </div>
  </div>




</ion-content>

<ion-modal [isOpen]="isManageModalOpen" (didDismiss)="dismissManageModal()">
  <ng-template>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="onManageBackClicked()">
            <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          @if (manageModalStep === 'cancel-reason') {
          Cancel subscription
          } @else if (manageModalStep === 'remove-reason') {
          Remove plan
          } @else {
          Manage Plan
          }
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      @if (manageModalStep === 'options') {
      <div class="p-4">
        <ion-list lines="full" class="rounded-md overflow-hidden bg-white">
          @if (canChangePaymentMethod(managingPlanPurchase)) {
          <ion-item button detail="false" (click)="onPaymentMethodClicked()">
            <ion-label>Change payment method</ion-label>
            <ion-icon slot="end" name="chevron-forward"></ion-icon>
          </ion-item>
          }
          @if (canCancelAutoRenew(managingPlanPurchase)) {
          <ion-item button detail="false" (click)="onCancelSubscriptionClicked()">
            <ion-label color="danger">Cancel subscription</ion-label>
          </ion-item>
          }
          @if (canRemovePlan(managingPlanPurchase)) {
          <ion-item button detail="false" (click)="onRemovePlanClicked()">
            <ion-label color="danger">Remove plan</ion-label>
          </ion-item>
          }
        </ion-list>
      </div>
      }

      @if (manageModalStep === 'cancel-reason') {
      <div class="flex flex-col gap-4 p-4">
        <p class="m-0 text-sm text-[var(--ion-color-two)]">Please tell us why you're cancelling</p>

        <ion-radio-group [(ngModel)]="selectedCancelReason">
          <ion-list lines="full" class="rounded-md overflow-hidden bg-white">
            @for (reason of cancelReasons; track reason) {
            <ion-item>
              <ion-radio color="dark" labelPlacement="end" justify="start" [value]="reason">{{ reason }}</ion-radio>
            </ion-item>
            }
          </ion-list>
        </ion-radio-group>

        @if (selectedCancelReason === cancelReasonOther) {
        <ion-textarea class="rounded-md overflow-hidden bg-white px-3" [(ngModel)]="otherCancelReason"
          placeholder="Tell us more" [autoGrow]="true" rows="3">
        </ion-textarea>
        }

        <super-button type="light" color="danger" iconEnd="chevron-forward" [disabled]="!canConfirmCancel"
          [action]="confirmCancelSubscription">
          Confirm cancellation
        </super-button>
      </div>
      }

      @if (manageModalStep === 'remove-reason') {
      <div class="flex flex-col gap-4 p-4">
        <p class="m-0 text-sm text-[var(--ion-color-two)]">
          Your plan will be removed immediately. Please tell us why you're removing it.
        </p>

        <ion-textarea mode="ios" class="rounded-md border border-gray-300 overflow-hidden bg-white p-3"
          [(ngModel)]="removeRemark" placeholder="Reason for removal" [autoGrow]="true" rows="3">
        </ion-textarea>

        <super-button type="light" color="danger" iconEnd="chevron-forward" [disabled]="!canConfirmRemove"
          [action]="confirmRemovePlan">
          Confirm removal
        </super-button>
      </div>
      }
    </ion-content>
  </ng-template>
</ion-modal>